import { call, put, select, takeEvery } from "redux-saga/effects";
import { push } from "react-router-redux";
import { toast } from 'react-toastify';
import {
    onSettingsLoad, onSettingsLoadFail, onSettingsLoadSuccess, onSettingsSave, onSettingsSaveFail,
    onSettingsSaveSuccess, COMPANY_DETAILS_SAVE, onCompanyDetailsSaveSuccess, onCompanyDetailsSaveFail, TAX_NEW_CREATE,
    onTaxNewCreateSuccess, onTaxNewCreateFail, PASSWORD_UPDATE, onPasswordUpdateSuccess, onPasswordUpdateFail,
    CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE, onChangeDefaultPaymentSystemSaveSuccess, onChangeDefaultPaymentSystemSaveFail,
    LOGOUT_SESSIONS, onLogoutSessionsSuccess, onLogoutSessionsFail, COMPANY_SETTING_LOAD, onCompanySettingLoadSuccess,
    onCompanySettingLoadFail, COMPANY_SETTING_LISTS_LOAD, onCompanySettingListsLoadSuccess, onCompanySettingListsLoadFail,
    COMPANY_SETTINGS_SAVE, onCompanySettingsSaveSuccess, onCompanySettingsSaveFail, ALL_TAX_LOAD, onAllTaxLoadSuccess,
    onAllTaxLoadFail, TAX_LOAD, onTaxLoadSuccess, onTaxLoadFail, TAX_DELETE, onTaxDeleteSuccess, onTaxDeleteFail,
    ALL_RESTORANTS_LOAD, onAllRestorantsLoadSuccess, onAllRestorantsLoadFail, onTaxFieldClear, USER_PROFILE_UPDATE,
    onUserProfileUpdateSuccess, onUserProfileUpdateFail, USER_PROFILE_LOAD, onUserProfileLoadSuccess, onUserProfileLoadFail,
    DEFAULT_PAYMENT_LOAD, onDefaultPaymentLoadSuccess, onDefaultPaymentLoadFail, STRIPE_SYSTEM_DEAUTHORIZE,
    onStripeSystemDeauthorizeSuccess, onStripeSystemDeauthorizeFail, YOOKASA_SYSTEM_DEAUTHORIZE, onYookassaSystemDeauthorizeSuccess,
    onYookassaSystemDeauthorizeFail, AMERIABANK_ACCOUNT_SAVE, onAmeriabankAccountSaveSuccess, onAmeriabankAccountSaveFail,
    AMERIABANK_ACCOUNT_DELETE, onAmeriabankAccountDeleteSuccess, onAmeriabankAccountDeleteFail, TWO_FACTOR_AUTH_CONFIRM_PASSWORD,
    TwoFactorAuthConfirmPasswordSuccess, TwoFactorAuthConfirmPasswordFail, REGENERATE_CODE, onRegenerateCodeSuccess,
    onRegenerateCodeFail, DELETE_ACCOUNT, onDeleteAccountSuccess, onDeleteAccountFail,
} from "./actions";
import {
    ameriabankAccountDelete, ameriabankAccountSave, browserSessionLogout, changeDefaultPaymentSystem, companySaveDetails,
    companySaveSettings, deleteAccount, getAllRestorants, getAllTax, getCompanySetting, getCompanySettingList, getDefaultPayment,
    getTax, getUserProfile, passwordUpdate, regenerateCode, settingsLoad, settingsSave, stripeSystemDeauthorize, taxDelete,
    taxNewCreate, twoFactorAuthConfirm, userProfileUpdate, yookassaSystemDeauthorize,
} from "./api";

function* settingsSubmit() {
    try {
        const { logo, splash } = yield select((state) => state.settings);
        const data = { logo, splash};

        const response = yield call(settingsSave, data);
        yield put(onSettingsSaveSuccess(response));
        yield put(push("/chain/design"));
    } catch (e) {
        yield put(onSettingsSaveFail(e));
    }
}

function* settingsLoadSg(action) {
    try {
        const response = yield call(settingsLoad);
        yield put(onSettingsLoadSuccess(response));
    } catch (e) {
        yield put(onSettingsLoadFail(e));
    }
}

function* companySettingLoadWorker() {
    try {
        const response = yield call(getCompanySetting);
        yield put(onCompanySettingLoadSuccess(response));
    } catch (e) {
        yield put(onCompanySettingLoadFail(e));
    }
}

function* companySettingListLoadWorker() {
    try {
        const response = yield call(getCompanySettingList);
        yield put(onCompanySettingListsLoadSuccess(response));
    } catch (e) {
        yield put(onCompanySettingListsLoadFail(e));
    }
}

function* companyDetailsSaveWorker(action) {
    try {
        const response = yield call( companySaveDetails, action.values);
        yield put(onCompanyDetailsSaveSuccess(response));
    } catch (e) {
        yield put(onCompanyDetailsSaveFail(e));
    }
}

function* companySettingsSaveWorker(action) {
    try {
        const response = yield call( companySaveSettings, action.values);
        yield put(onCompanySettingsSaveSuccess(response));
    } catch (e) {
        yield put(onCompanySettingsSaveFail(e));
    }
}

function* taxLoadWorker(action) {
    try {
        const response = yield call(getTax, action.taxId);
        yield put(onTaxLoadSuccess(response));
    } catch (e) {
        yield put(onTaxLoadFail(e));
    }
}

function* taxDeleteWorker(action) {
    try {
        const response = yield call(taxDelete, action.taxId);
        yield put(onTaxDeleteSuccess(response));
        yield put(onTaxFieldClear());
    } catch (e) {
        yield put(onTaxDeleteFail(e));
    }
}

function* allTaxLoadWorker() {
    try {
        const response = yield call(getAllTax);
        yield put(onAllTaxLoadSuccess(response));
    } catch (e) {
        yield put(onAllTaxLoadFail(e));
    }
}

function* taxNewCreateWorker(action) {
    try {
        const response = yield call(taxNewCreate, action);
        yield put(onTaxNewCreateSuccess(response));
        yield put(onTaxFieldClear());
    } catch (e) {
        yield put(onTaxNewCreateFail(e));
    }
}

function* allRestorantsLoadWorker() {
    try {
        const response = yield call(getAllRestorants);
        yield put(onAllRestorantsLoadSuccess(response));
    } catch (e) {
        yield put(onAllRestorantsLoadFail(e));
    }
}

function* userProfileLoadWorker() {
    try {
        const response = yield call(getUserProfile);
        yield put(onUserProfileLoadSuccess(response));
    } catch (e) {
        yield put(onUserProfileLoadFail(e));
    }
}

function* userProfileUpdateWorker(action) {
    try {
        const response = yield call( userProfileUpdate, action.values);
        yield put(onUserProfileUpdateSuccess(response));
    } catch (e) {
        yield put(onUserProfileUpdateFail(e));
    }
}

function* passwordUpdateWorker(action) {
    try {
        const response = yield call( passwordUpdate, action.values);
        yield put(onPasswordUpdateSuccess(response));
    } catch (e) {
        yield put(onPasswordUpdateFail(e));
    }
}

function* defaultPaymentLoadWorker() {
    try {
        const response = yield call(getDefaultPayment);
        yield put(onDefaultPaymentLoadSuccess(response));
    } catch (e) {
        yield put(onDefaultPaymentLoadFail(e));
    }
}

function* changeDefaultPaymentSystemSaveWorker(action) {
    try {
        const response = yield call( changeDefaultPaymentSystem, action.params);
        yield put(onChangeDefaultPaymentSystemSaveSuccess(response));
    } catch (e) {
        yield put(onChangeDefaultPaymentSystemSaveFail(e));
    }
}

function* stripeSystemDeauthorizeWorker(action) {
    try {
        const response = yield call( stripeSystemDeauthorize, action.accountId);
        yield put(onStripeSystemDeauthorizeSuccess(response));
    } catch (e) {
        yield put(onStripeSystemDeauthorizeFail(e));
    }
}

function* yookassaSystemDeauthorizeWorker(action) {
    try {
        const response = yield call( yookassaSystemDeauthorize, action.accountId);
        yield put(onYookassaSystemDeauthorizeSuccess(response));
    } catch (e) {
        yield put(onYookassaSystemDeauthorizeFail(e));
    }
}

function* ameriabankAccountSaveWorker(action) {
    try {
        const response = yield call( ameriabankAccountSave, action.values);
        yield put(onAmeriabankAccountSaveSuccess(response));
    } catch (e) {
        yield put(onAmeriabankAccountSaveFail(e));
    }
}

function* ameriabankAccountDeleteWorker() {
    try {
        const response = yield call( ameriabankAccountDelete);
        yield put(onAmeriabankAccountDeleteSuccess(response));
    } catch (e) {
        yield put(onAmeriabankAccountDeleteFail(e));
    }
}

function* logoutSessionsWorker(action) {
    try {
        const response = yield call( browserSessionLogout, action.pass);
        yield put(onLogoutSessionsSuccess(response));
    } catch (e) {
        yield put(onLogoutSessionsFail(e));
    }
}

function* twoFactorAuthConfirmPasswordWorker(action) {
    try {
        const { is_two_factor_enabled } = yield select(({settings}) => settings.user_profile);

        const response = yield call( twoFactorAuthConfirm, action.pass, is_two_factor_enabled);
        yield put(TwoFactorAuthConfirmPasswordSuccess(response));
    } catch (e) {
        yield put(TwoFactorAuthConfirmPasswordFail(e));
    }
}

function* regenerateCodeWorker(action) {
    try {
        const response = yield call(regenerateCode, action.pass);
        yield put(onRegenerateCodeSuccess(response));
    } catch (e) {
        yield put(onRegenerateCodeFail(e));
    }
}

function* deleteAccountWorker(action) {
    try {
        const response = yield call( deleteAccount, action.pass);
        yield put(onDeleteAccountSuccess(response));
        yield put(push("/login"));
    } catch (e) {
        yield put(onDeleteAccountFail(e));
        yield toast.error("Invalid Password")
    }
}

function* settingsSaga() {
    yield takeEvery(onSettingsSave().type, settingsSubmit);
    yield takeEvery(onSettingsLoad().type, settingsLoadSg);
    yield takeEvery(COMPANY_SETTING_LOAD, companySettingLoadWorker);
    yield takeEvery(COMPANY_SETTING_LISTS_LOAD, companySettingListLoadWorker);
    yield takeEvery(COMPANY_DETAILS_SAVE, companyDetailsSaveWorker);
    yield takeEvery(COMPANY_SETTINGS_SAVE, companySettingsSaveWorker);
    yield takeEvery(TAX_NEW_CREATE, taxNewCreateWorker);
    yield takeEvery(TAX_LOAD, taxLoadWorker);
    yield takeEvery(TAX_DELETE, taxDeleteWorker);
    yield takeEvery(ALL_TAX_LOAD, allTaxLoadWorker);
    yield takeEvery(ALL_RESTORANTS_LOAD, allRestorantsLoadWorker);
    yield takeEvery(USER_PROFILE_LOAD, userProfileLoadWorker);
    yield takeEvery(USER_PROFILE_UPDATE, userProfileUpdateWorker);
    yield takeEvery(PASSWORD_UPDATE, passwordUpdateWorker);
    yield takeEvery(DEFAULT_PAYMENT_LOAD, defaultPaymentLoadWorker);
    yield takeEvery(CHANGE_DEFAULT_PAYMENT_SYSTEM_SAVE, changeDefaultPaymentSystemSaveWorker);
    yield takeEvery(STRIPE_SYSTEM_DEAUTHORIZE, stripeSystemDeauthorizeWorker);
    yield takeEvery(YOOKASA_SYSTEM_DEAUTHORIZE, yookassaSystemDeauthorizeWorker);
    yield takeEvery(AMERIABANK_ACCOUNT_SAVE, ameriabankAccountSaveWorker);
    yield takeEvery(AMERIABANK_ACCOUNT_DELETE, ameriabankAccountDeleteWorker);
    yield takeEvery(LOGOUT_SESSIONS, logoutSessionsWorker);
    yield takeEvery(TWO_FACTOR_AUTH_CONFIRM_PASSWORD, twoFactorAuthConfirmPasswordWorker);
    yield takeEvery(REGENERATE_CODE, regenerateCodeWorker);
    yield takeEvery(DELETE_ACCOUNT, deleteAccountWorker);
}

export default settingsSaga;
